import React, {useState,useEffect} from 'react'
import Nav from '../../globalComponents/nav/Nav';
import './userProfile.css'
import { MDBBtn,MDBInput, MDBInputGroup, MDBTextArea } from 'mdb-react-ui-kit';
import Form from 'react-bootstrap/Form';
import { useNavigate,useParams } from 'react-router-dom';
import Footer from '../../globalComponents/footer/Footer';
// import Resizer from "react-image-file-resizer";
import Url from '../url'


function UserProfile() {
    //testing file resize
    const [newImageFile, setNewImageFile] = useState()
    
    const navigate = useNavigate()
    let { userId } = useParams()

    const [token,setToken] = useState(null)
    const [currentUserEmail, setCurrentUserEmail] = useState(undefined)
    const [admin, setAdmin ] = useState(null)

    const [userImage, setUserImage] = useState()
    const [userImageIsLink, setUserImageIsLink] =useState()

    const [ userIsAdmin , setUserIsAdmin ] = useState(false)
    const [ fName, setfName ] = useState("")
    const [ lName, setlName ] = useState("")
    const [ phone, setPhone ] = useState("")
    const [ raverlyAccount, setRaverlyAccount ] = useState("")
    const [ smoker, setSmoker ] = useState(false)
    const [ country, setCountry ] = useState("")
    const [ otherCountry, setOtherCountry ] = useState("")

    const [ state, setState ] = useState("")
    const statesArray = ['','Alabama','Alaska','American Samoa','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Federated States of Micronesia','Florida','Georgia','Guam','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Marshall Islands','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Northern Mariana Islands','Ohio','Oklahoma','Oregon','Palau','Pennsylvania','Puerto Rico','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virgin Island','Virginia','Washington','West Virginia','Wisconsin','Wyoming']
    
    const [ aboutMe, setAboutMe ] = useState("")

    const [ password1, setPassword1 ] = useState("")
    const [ password2, setPassword2 ] = useState("")

    const [ tokenLoaded, setTokenLoaded] = useState(false)
    
    //** Skills section*/
    
    const skillLevels = ["","Beginner","Intermediate","Expert"]

    const [ knitSkill, setKnitSkill ] = useState("")
    const [ crochetSkill, setCrochetSkill ] = useState("")
    const [ quiltSkill, setQuiltSkill ] = useState("")
    const [ embroiderySkill, setEmbroiderySkill ] = useState("")
    const [ sewSkill, setSewSkill ] = useState("")
    const [ crossStitchSkill, setCrossStitchSkill ] = useState("")
    const [ weaveSkill, setWeaveSkill ] = useState("")
    const [ weaveLoomSkill, setWeaveLoomSkill ] = useState("")
    const [ laceSkill, setLaceSkill ] = useState("")
    const [ rugMakingSkill, setRugMakingSkill ] = useState("")
    const [ additionalSkills, setAdditionalSkills] = useState("")

    
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    
    
    //retrieve the token + admin + email
    //** function to render skill levels () */
    
    useEffect(() =>  {
        if (localStorage.getItem("user")) {
            
            //setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ?  setAdmin(true) : setAdmin(false)
            setToken(localStorage.getItem("token").slice(0,3)+localStorage.getItem("token").slice(4))
            setTokenLoaded(true)
        }
        else {//TODO if localstorage user not found redirect to "/"
            console.log(`user local storage not found`)
            return (navigate("/"))
        }
        }, [])

    
    //first fetch  the user Info if token is loaded from local storage
    useEffect(()=>{
        //fetch user info here
        if (tokenLoaded) {
            fetch (Url+`user/getUserInfo/${userId}`,{
                method:"GET",
                body: null,
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization" : token
                })
            })
            .then(res=> res.json())
            .then(data=> {
                console.log(data)
                if (data.error) {
                    alert (data.error)
                }
                else if (data.user)
                { data.user.avatar 
                    ? data.user.avatar.includes("https://") 
                        ? setUserImageIsLink(data.user.avatar)
                        : setUserImage(data.user.avatar)
                    : setUserImage (null)
                    
                    //console.log(data.user.allSkills.knitSkill)
                    setfName(data.user.fName)
                    setlName(data.user.lName)
                    setCurrentUserEmail(data.user.email)
                    setPhone(data.user.phone)
                    
                    if (data.user.country == "us"){
                        setCountry(data.user.country)
                        setState(data.user.state) 
                    }
                    else {
                        setCountry ("other")
                        setOtherCountry(data.user.country)
                    }
                    
                    setSmoker(data.user.smoker)
                    setAboutMe(data.user.aboutMe)
                    setRaverlyAccount(data.user.raverlyAccount)
                    setUserIsAdmin(data.user.isAdmin)
                    if (data.user.allSkills){
                        setKnitSkill(data.user.allSkills.knitSkill)
                        setCrochetSkill(data.user.allSkills.crochetSkill)
                        setQuiltSkill(data.user.allSkills.quiltSkill)
                        setEmbroiderySkill(data.user.allSkills.embroiderySkill)
                        setSewSkill(data.user.allSkills.sewSkill)
                        setCrossStitchSkill(data.user.allSkills.crossStitchSkill)
                        setWeaveSkill(data.user.allSkills.weaveSkill)
                        setWeaveLoomSkill(data.user.allSkills.weaveLoomSkill)
                        setLaceSkill(data.user.allSkills.laceSkill)
                        setRugMakingSkill(data.user.allSkills.rugMakingSkill)
                        setAdditionalSkills(data.user.allSkills.additionalSkills)
                    }
                }

                })
            .catch(err => {
                console.log(err)
            })}
    },[tokenLoaded])

//delete users profile
    function deleteProfile(){
        let alert1,alert2

        alert1 = confirm("Do you want to delete this account")
        alert1 ? alert2 = confirm("Do you really want to DELETE THIS ACCOUNT") : alert1 = false

        if (alert2) {
            //TODO fetch to new endpoint
            fetch (Url+`user/deleteProfile/${userId}`,{
                method:"DELETE",
                body: null,
                headers: new Headers({
                    //"Content-Type": "multipart/form-data",
                    "authorization" : token
            })
        })
        .then(res=> res.json())
        .then(data=>{
            if (data.error){
                console.log(data.error)
            }
            else {
                localStorage.clear()
                navigate("/")
            } 
        })

            console.log(`deleeeting account`)
            
        }
    }   

    

    function updatePassword(){
        if (password1 != password2) {
            alert(`The two passwords do not match`)
            setPassword1("")
            setPassword2("")
        } 
        else{
            //TODO fetch new password to the auth endpoint
        }
    }

    //!image resizer is HERE
    const resizeFile = (file) =>
    new Promise((resolve) => {
        Resizer.imageFileResizer( file, 200, 200, "JPEG", 100, 0, (uri) => {resolve(uri)}, "base64");
    });

    async function resizeImage(imageToGetResized){
        const resizedImage = await resizeFile(imageToGetResized);
        let resizedTempFile = new File([resizedImage], `${imageToGetResized.name}`,{ type: "image/jpeg" });
        return resizedTempFile
    }

    // 
    async function fileSrc(e){
        e.preventDefault()
        if (e.target.files.length > 0){
            /*console.log(`here`)
            let something = await resizeImage(e.target.files[0])
            console.log(something)
            setUserImage(something) 
            */
            setUserImage(e.target.files[0])
        }
        else{
            console.log(`not in e.target`)
            setUserImage(null)
        }
        }


    // function uploads formdata to express server
    async function updateProfile(e){
        e.preventDefault()
        const formData = new FormData();
        // create a array of all the skills and their values
        let allSkills = {
            knitSkill,
            crochetSkill,
            quiltSkill,
            embroiderySkill,
            sewSkill,
            crossStitchSkill,
            weaveSkill,
            weaveLoomSkill,
            laceSkill,
            rugMakingSkill,
            additionalSkills
            }

        allSkills = JSON.stringify(allSkills)
        
        //TODO resize the avatar if it is provided
        
        userImageIsLink ? formData.append("userImageIsLink",true) : formData.append("userImage",userImage)

        
        formData.append("fName",fName)
        formData.append("lName",lName)
        formData.append("phone",phone)
        formData.append("smoker",smoker)
        
        if (country =="us"){
            formData.append("country",country)
            formData.append("state",state)
        }
        else{
            formData.append("country",otherCountry)
            formData.append("state","")
        }
        formData.append("raverlyAccount",raverlyAccount)
        formData.append("isAdmin",userIsAdmin)
        formData.append("aboutMe",aboutMe)
        formData.append("allSkills",allSkills)



        fetch (Url+`user/updateProfile/${userId}`,{
            method:"POST",
            body: formData,
            headers: new Headers({
                //"Content-Type": "multipart/form-data",
                "authorization" : token
            })
        })
        .then(res=> res.json())
        .then(data=>{
            data.error ? console.log(data.error): navigate(`/userProfile/${userId}`)})
    }

    return (
    <>
    <Nav></Nav>

    <div className='container-lg' style={{marginTop:"120px"}}>
        
        <div className='row pb-4'>
            <div className='col-2 pd-1' style={{textAlign:"center"}}>
                Profile Picture:
                <img className="img-thumbnail" alt="No image selected" src={
                    userImageIsLink ? userImageIsLink : 
                        userImage? URL.createObjectURL(userImage) : null}/>
                    <input type="file" id="choose-file" name="choose-file" accept="image/*" 
                        onChange={e=>fileSrc(e)}/>
                <label className="btn btn-primary btn-sm bg-gradient" htmlFor="choose-file">Choose File</label>
                <button  className='btn btn-primary btn-sm bg-gradient' onClick={e=>{setUserImageIsLink(null);setUserImage(null)}}>remove</button>
            </div>

            <div className='col-2'>
            </div>

            <div className='col pb-1'>
                <div className='row pb-2'>
                    <h5>Username: {currentUserEmail}</h5>
                </div>
                
                <div className="input-group">
                        <MDBInput value={fName} label='First Name'onChange={e => setfName(e.target.value)}/>
                        <MDBInput value={lName} label='Last Name' onChange={e => setlName(e.target.value)}/>
                </div>
                    
                <div className="input-group">
                        <MDBInput value={phone} label='Phone Number' onChange={e => setPhone(e.target.value)}/>
                        <MDBInput value={raverlyAccount} label='Ravelry Account' onChange={e => setRaverlyAccount(e.target.value)}/>
                </div>
            
                <div className='col-4 pb-4'>
                    Country:
                    <div className="input-group">
                            <Form.Select className='skillDrop' value={country} aria-label="Country" onChange={e=>setCountry(e.target.value)}>
                                <option value="us">United States</option>
                                <option value="other">Other</option>
                            </Form.Select>

                            {country == "us" && 
                                <div className='col-md-5'>
                                    <Form.Select className='skillDrop' aria-label="states" value= {state} onChange={e=>setState(e.target.value)}>
                                        {statesArray.map((state)=><option key={state} value={state}>{state}</option>)}
                                    </Form.Select>
                                </div>
                            }

                            {country == "other" && 
                                <div className='col-md-5'>
                                    <MDBInput value={otherCountry} label='Country' onChange={e => setOtherCountry(e.target.value)}/>
                                </div>
                            }
                    </div>
                    
                </div>
                
                <div className="form-check">
                    <input className="form-check-input" checked={smoker} type="checkbox" name="" id="smokerCheckbox" onChange={e=>setSmoker(e.target.checked)}/>
                    <label className="form-check-label" htmlFor="smokerCheckbox">I live in a smoker house</label>
                </div>

            </div>
        </div>
        
        <div className='row pb-4'>
            <div className='col-md-7'>
                <MDBTextArea rows="2"  
                    placeholder='write something about yourself.'
                    value={aboutMe}
                    onChange={e=>setAboutMe(e.target.value)}
                    label='Desribe yourself'>
                </MDBTextArea>
            </div>
        </div>

        <div className='row pb-2'>
            <h3>Select your skills:</h3>
            <h6>* at least one skill is required to become a finisher</h6>
        </div>
        
        <div className='row pb-4'>
            <div className='col-md-3 pb-3'> 
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Knitting skill level" className="input-group-text">Knitting</span>
                    <Form.Select className='skillDrop' value={knitSkill} aria-label="Knitting Skill level" onChange={e=>setKnitSkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
            
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Crocheting skill level" className="input-group-text">Crocheting</span>
                    <Form.Select className='skillDrop' value={crochetSkill} aria-label="crochet skill level" onChange={e=>setCrochetSkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
            
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Quilting skill level" className="input-group-text">Quilting</span>
                    <Form.Select className='skillDrop' value={quiltSkill} aria-label="Quilting skill level" onChange={e=>setQuiltSkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
            </div>
            
            <div className='col-md-3 pb-3'> 
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Embroidery skill level" className="input-group-text">Embroidery</span>
                    <Form.Select className='skillDrop' value={embroiderySkill} aria-label="Embroidery skill level" onChange={e=>setEmbroiderySkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
                
            
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Sewing skill level" className="input-group-text">Sewing</span>
                    <Form.Select className='skillDrop' value={sewSkill} aria-label="Sewing skill level" onChange={e=>setSewSkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
                
            
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Cross Stitch skill level" className="input-group-text">Cross Stitch</span>
                    <Form.Select className='skillDrop' value={crossStitchSkill} aria-label="Cross Stitch skill level" onChange={e=>setCrossStitchSkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
            </div>

            <div className='col-md-3 pb-3'>
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Weaving / Tapestry skill level" className="input-group-text">Weaving/Tapestry</span>
                    <Form.Select className='skillDrop' value={weaveSkill} aria-label="Weaving / Tapestry skill level" onChange={e=>setWeaveSkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>

                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Weaving/Loom skill level" className="input-group-text">Weaving/Loom</span>
                    <Form.Select className='skillDrop' value={weaveLoomSkill} aria-label="Weaving/Loom skill level" onChange={e=>setWeaveLoomSkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
                
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Lace skill level" className="input-group-text">Lace</span>
                    <Form.Select className='skillDrop' value={laceSkill} aria-label="Lace skill level" onChange={e=>setLaceSkill(e.target.value)}>
                            {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
            </div>

        
            <div className='col-md-3 pb-3'>
                <MDBInputGroup>
                    <span data-mdb-toggle="tooltip" title="Rug-Making skill level" className="input-group-text">Rug-Making</span>
                    <Form.Select className='skillDrop' value={rugMakingSkill} aria-label="Rug-Making skill level" onChange={e=>setRugMakingSkill(e.target.value)}>
                    {skillLevels.map((level)=><option key={level} value={level}>{level}</option>)}
                    </Form.Select>
                </MDBInputGroup>
            </div>
        </div>
            
        <div className='row pb-4'>
            <div className='col-md-7'>
                <MDBTextArea rows="2" 
                    placeholder='Enter additional skills or preferences eg: things you love to work on / things you wont work on'
                    value={additionalSkills}
                    onChange={e=>setAdditionalSkills(e.target.value)}
                    label='Additional Skills & Preferences'>
                </MDBTextArea>
            </div>
        </div>
        <div className='row-lg pb-2'>
            { admin &&
            <div className="form-check">
                <input className="form-check-input" checked={userIsAdmin} 
                    type="checkbox" 
                    name="" 
                    id="isAdminCheckbox" 
                    onChange={e=>setUserIsAdmin(e.target.checked)}/>
                <label className="form-check-label" htmlFor="isAdminCheckbox">
                    <p className="text-danger"><strong> Administrator privileges</strong></p>
                    </label>
            </div>
            }
        </div>
        <div className='row-lg pb-4'>
            
            <p className="text-warning"><strong><em>Change Password Form:</em></strong></p>
            <em>Enter New Password. Password must be at lest 6 characters long!</em>
            <form>
            <div className="input-group">
                <MDBInput type="password" autoComplete="new-password" value={password1} label='New Password'onChange={e => setPassword1(e.target.value)}/>
                <MDBInput type="password" autoComplete="new-password" value={password2} label='Confirm New Password' onChange={e => setPassword2(e.target.value)}/>
            </div>
            <button type='button' className='btn btn-warning btn-sm' onClick={updatePassword} >Save new password</button>
            </form>
        </div>
            
        
        <div className='row-lg pb-4'>
            <button type="button" className="btn btn-danger btn-sm" onClick={deleteProfile} >DELETE THIS ACCOUNT</button>
        </div>

        <div className='row pb-4' >
            <div className='col-md-5 pb-2'>
                <button type="button" className="btn btn-primary" onClick={e=>updateProfile(e)}>Update profile</button>
            </div>
            <div className='col-md-5 pb-2'>
                <button type="button" className="btn btn-primary" onClick={e=>navigate("/")}>Cancel</button>
            </div>
            
        </div>
        
    </div>    
    <Footer/>
    </>
    )
}

export default UserProfile